export const USER_CONSENT = {
  FEATURE_AXIA_NETWORK_TOKEN: "FEATURE_AXIA_NETWORK_TOKEN",
  AXIA_NETWORK_V2_TOKEN_MIGRATION: "AXIA_NETWORK_V2_TOKEN_MIGRATION",
  USAX_ACCOUNT: "USAX_ACCOUNT"
};
